// @ts-nocheck

import 'normalize.css';
import Vue from 'vue';
import globalComponents from '@/components/global';
import * as filters from '@/filters/index';
import { getToken, setToken } from './share'
import {
  Button,
  Field,
  Dialog,
  Tag,
  Image,
  Overlay,
  Popup,
  Picker,
  NoticeBar,
  List,
  TreeSelect,
  Search,
  Toast,
  Sticky,
  DropdownItem,
  DropdownMenu,
  Cell,
  Radio,
  RadioGroup,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  NavBar
} from '@zyf2e/capui-mobile';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import { getUrlParam } from '@/utils';
import '@/styles/index.less';
import { initAdapter, getAdapter, env, axios } from '@zyf2e/adapt';
import * as Telescope from '@zyf2e/telescope';

window.Vue = Vue;

Vue.use(Button)
  .use(Field)
  .use(Tag)
  .use(Image)
  .use(Overlay)
  .use(Popup)
  .use(Picker)
  .use(NoticeBar)
  .use(List)
  .use(TreeSelect)
  .use(Search)
  .use(Dialog)
  .use(Toast)
  .use(Sticky)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Cell)
  .use(Radio)
  .use(RadioGroup)
  .use(CellGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(NavBar);

Vue.config.productionTip = false;

type globalComponentsKey = keyof typeof globalComponents;

(Object.keys(globalComponents) as globalComponentsKey[]).forEach(key => {
  Vue.component(key, globalComponents[key]);
});

type filtersKey = keyof typeof filters;

(Object.keys(filters) as filtersKey[]).forEach(key => {
  Vue.filter(key, filters[key]);
});

router.beforeEach(async ({ meta, fullPath, query }, from, next) => {
  const adapter = getAdapter();
  const { title = '', authorization = false } = meta;
  adapter.setTitle(title);

  if (query.token) {
    console.log('token: ', query.token);
    setToken(query.token)
  }

  if (authorization && !adapter.isLogin()) {
    await adapter.login(window.location.href.replace(/(#\/(.+)?)/g, `#${fullPath}`));
    return;
  }

  next();
});

// #region 埋点代码
Vue.directive('track-event', Telescope.vTrackEvent);
Telescope.setConfig({
  autoTrackClick: false,
  trackKey: 'acd2bf9921d1c93e260c4626e1a7d88b',
  version: '1.0.0'
});
router.afterEach(to => {
  if (to.meta.telescope) {
    Telescope.trackPage({ trackId: to.meta.telescope });
  }
});
// #endregion

async function main() {
  const channel = getUrlParam('channel');
  if (channel) sessionStorage.setItem('channel', channel);
  await initAdapter({
    baseURL: process.env.VUE_APP_API,
    h5LoginUrl: process.env.VUE_APP_LOGIN,

    wechatAPIList: [
      'updateAppMessageShareData',
      'updateTimelineShareData',
      'showOptionMenu',
      'hideOptionMenu',
      'hideAllNonBaseMenuItem',
      'showAllNonBaseMenuItem',
      'hideMenuItems',
      'showMenuItems'
      // 'geoLocation',
      // 'closeWindow'
    ],
    checkOpenIdType: 'ZYJK_SUBSCRIBE'
  });

  axios.axios.interceptors.request.use((config) => {
    if (getToken()) {
      config.headers.token = getToken()
    }
    return config;
  })

  const adapter = getAdapter();
  if (env.inWechat) {
    adapter.wx.ready(() => {
      adapter.wx.hideMenuItems({
        menuList: ['menuItem:copyUrl']
      });
    });
  }


  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
}

// console.log('localStorage.getItem', window.parent.localStorage.getItem('x'))

main();
